import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalPopoverPageRoutingModule } from './modal-popover-routing.module';

import { ModalPopoverPage } from './modal-popover.page';

import { OpenHoursPageModule } from '../../../open-hours/open-hours.module';

import { LoginPageModule } from '../../../login/login.module';

import { ProfileUpdatePageModule } from '../../../profile-update/profile-update.module';

import { RegisterViaPageModule } from '../../../register-via/register-via.module';

import { RegisterPageModule } from '../../../register/register.module';

import { PagesPageModule } from '../../../pages/pages.module';

import { ForgotPasswordPageModule } from '../../../forgot-password/forgot-password.module';

import { ToppingsPageModule } from '../../../modals/toppings/toppings.module';

import { CheckoutPageModule } from '../../../checkout/checkout.module';

import { OrderSummeryPageModule } from '../../../order-summery/order-summery.module';

import { PastOrderPageModule } from '../../../past-order/past-order.module';

import { CrossSellingPageModule } from '../../../modals/cross-selling/cross-selling.module';

import { TableReservationPageModule } from '../../../modals/table-reservation/table-reservation.module';

import { AdditivesAndSubstancesPageModule } from '../../../additives-and-substances/additives-and-substances.module';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalPopoverPageRoutingModule,
    TranslateModule,
    CheckoutPageModule,
    LoginPageModule,
    RegisterPageModule,
    RegisterViaPageModule,
    OpenHoursPageModule,
    LoginPageModule,
    ProfileUpdatePageModule,
    PagesPageModule,
    ToppingsPageModule,
    OrderSummeryPageModule,
    PastOrderPageModule,
    CheckoutPageModule,
    ForgotPasswordPageModule,
    CrossSellingPageModule,
    TableReservationPageModule,
    AdditivesAndSubstancesPageModule
  ],
  declarations: [ModalPopoverPage]
  , providers: []
})
export class ModalPopoverPageModule { }